import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { Metric } from 'webapp/models-custom';
import type SourceType from 'webapp/models-custom/source-type';
import type SourceRecord from 'webapp/models/source';

export default class MetricLibrarySourceController extends Controller {
	declare model: SourceType;
	@tracked source: SourceRecord | null = null;

	@action
	sendSourceChange(sourceKey: string | number): void {
		this.send('changeSource', sourceKey);
	}

	@action
	sendAddMetricsToBoard(selectedMetrics: Metric[]): void {
		return this.send('addMetricsToBoard', selectedMetrics);
	}
}
